/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocCheckIcon16Solid = forwardRef('DocCheckIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1H8v3.5A1.5 1.5 0 0 0 9.5 6H13v6.5a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 12.5v-9A2.5 2.5 0 0 1 4.5 1Zm6.322 7.63a.625.625 0 0 0-.884-.884l-2.919 2.918a.375.375 0 0 1-.53 0L5.477 9.652a.625.625 0 1 0-.884.884l1.012 1.012a1.625 1.625 0 0 0 2.298 0l2.919-2.919Z" }),
        React.createElement("path", { d: "M13 4.99V5H9.5a.5.5 0 0 1-.5-.5V1h.01L13 4.99Z" })));
});
